'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faArrowUpRightFromSquare } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import { faHiveHeartLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import DeleteFavoritesListModal from './DeleteFavoritesListModal';
import EditFavoritesListModal from './EditFavoritesListModal';
import { useAppContext } from '@/app/_lib/_context';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
const FavoritesCard = ({
  favoritesList,
  favoritesListIndex,
  refreshFavorites,
  deleteFavoritesList,
  allFavoritesLists = [],
  animatingProducts = {}
}) => {
  const {
    openFavoritesModal
  } = useAppContext();
  const [listName, setListName] = useState(favoritesList.list_name);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  // Sync listName when favoritesList prop changes
  useEffect(() => {
    setListName(favoritesList.list_name);
  }, [favoritesList.list_name]);
  const handleEditButtonClick = () => {
    setEditModalOpen(true);
  };
  const handleItemClick = (event, sub_product) => {
    event.preventDefault();
    event.stopPropagation();
    openFavoritesModal({
      sub_product_id: sub_product.sub_product_id,
      onClose: refreshFavorites,
      hide_manage_button: true
    });
  };
  const handleDeleteListClick = () => {
    setDeleteModalOpen(true);
  };
  const confirmDeleteList = targetListIndex => {
    // targetListIndex is the list to move products to (or null to delete them)
    deleteFavoritesList(favoritesListIndex, targetListIndex);
  };
  const handleListRenamed = newName => {
    if (newName) {
      favoritesList.list_name = newName;
      setListName(newName);
    }
  };
  const getProductImage = product => {
    if (product.thumb_1) {
      return `${process.env.NEXT_PUBLIC_RESOURCE_URL}/thumbs/${product.thumb_1}`;
    }
    if (product.product_photo) {
      return `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${product.product_photo}`;
    }
    return null;
  };
  return <>
            <DeleteFavoritesListModal isOpen={deleteModalOpen} setIsOpen={setDeleteModalOpen} contentLabel={'Delete Favorites List'} favoritesList={favoritesList} favoritesListIndex={favoritesListIndex} allFavoritesLists={allFavoritesLists} onConfirmDelete={confirmDeleteList} onListRenamed={handleListRenamed} />
            <EditFavoritesListModal isOpen={editModalOpen} setIsOpen={setEditModalOpen} contentLabel={'Rename Favorites List'} favoritesList={favoritesList} favoritesListIndex={favoritesListIndex} onListRenamed={handleListRenamed} />
            <div className="relative border-0.5 bg-gray-3 p-6">
                <div className="mb-10">
                    <button type="button" onClick={handleEditButtonClick} className="block text-md tracking-wide capitalize text-dark text-left">
                        {listName} <span className="text-light">({favoritesList.favorites.length} favorites)</span>
                        <div>{favoritesListIndex === 0 && <span className="text-sm text-primary">Default</span>}</div>
                    </button>
                </div>
                <div className="grid grid-cols-2 md:flex md:flex-wrap items-centermd gap-10 mb-10 p-4">
                    {favoritesList.products?.length > 0 && favoritesList.products.map((product_0, index) => {
          const animationState = animatingProducts[product_0.sub_product_id];
          const isHidden = animationState === 'fading-out' || animationState === 'fading-in-start';
          const isFadingIn = animationState === 'fading-in-start' || animationState === 'fading-in-end';
          const duration = isFadingIn ? 'duration-700' : 'duration-300';
          return <div key={product_0.sub_product_id} className={`group cursor-pointer transition-all ${duration} ease-out ${isHidden ? 'opacity-0 scale-95' : 'opacity-100 scale-100'}`}>
                                <Link href={product_0.url} className="w-[120px] h-[120px] overlay-block mx-auto">
                                    <Image className="w-[120px] h-[120px]" src={getProductImage(product_0)} alt={decodeEntities(product_0.sub_product_name)} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={120} height={120} quality={90} />
                                </Link>
                                <div className="visible lg:invisible lg:group-hover:visible flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 mt-5">
                                    <button className="text-sm text-light hover:text-primary transition-colors underline" onClick={e => handleItemClick(e, product_0)}><FontAwesomeIcon icon={faPenToSquare} className="inline text-xs mr-1" /> Edit Favorite</button>
                                    <Link href={product_0.url} className="text-sm text-light hover:text-primary transition-colors underline"><FontAwesomeIcon icon={faArrowUpRightFromSquare} className="inline text-xs mr-1" /> Go To Product</Link>
                                </div>
                            </div>;
        })}
                    {!favoritesList.products?.length && <div className="flex flex-col items-center justify-center w-full h-[200px]">
                            <h3 className="font-medium text-sm">No Favorites Yet</h3>
                            <em className="text-2xs">click the <FontAwesomeIcon icon={faHiveHeartLight} className="inline text-2xs" /> next to any product to add a favorite</em>
                        </div>}
                </div>
                <div className="flex justify-end">
                    <button type="button" onClick={handleEditButtonClick} className="text-sm text-light underline mr-4 hover:text-primary transition-colors duration-200"><FontAwesomeIcon icon={faPenToSquare} className="inline text-sm mr-1" /> Edit List</button>
                    {favoritesListIndex > 0 && <button type="button" onClick={handleDeleteListClick} className="text-sm text-light underline hover:text-red-600 transition-colors duration-200"><FontAwesomeIcon icon={faTrash} className="inline text-sm mr-1" /> Delete List</button>}
                </div>
            </div>
        </>;
};
export default FavoritesCard;